module.exports = __webpack_public_path__ + "assets/img/5_1180.04fb9bdf.jpg";